import { FaFacebookF, FaInstagram } from 'react-icons/fa';

// Une seule source pour les comptes du site : le pied de page et la page contact
// les affichent tous les deux.
export const SOCIAL_LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/lacana_cbd/',
    Icon: FaInstagram
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=100083152759630',
    Icon: FaFacebookF
  }
];
